export default "__VITE_ASSET__NedSYCve__"